import React from 'react'
import Navbar from './Navbar'
import Home from '../components/Home'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import PrivacyPolicy from './PrivacyPolicy'
import Footer from './Footer'
import TermsOfService from './TermsOfService'
import ScrollToTop from './ScrollToTop'
import HowItWork from './HowItWork'
import SecurityPage from './SecurityPage'
import AboutUsPage from './AboutUsPage'
import FAQPage from './FAQPage'
import PricingPage from './PricingPage'
import ReleaseNotes from './ReleaseNotes'
import Error404Page from './Error404Page'
import CanonicalLink from './CanonicalLink'
import SeoMeta from './SeoMeta'



const MainRouting = () => {
  const location = useLocation()
  const { pathname, search, hash } = location

  if (pathname !== '/' && pathname.endsWith('/')) {
    const normalizedPath = pathname.replace(/\/+$/, '')

    return <Navigate to={`${normalizedPath}${search}${hash}`} replace />
  }

  return (
    <div>
    <ScrollToTop/>
       <CanonicalLink/>
       <SeoMeta/>
       <Navbar/>
       <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
        <Route path='/terms-of-service' element={<TermsOfService/>}/>
        <Route path='/how-it-works' element={<HowItWork/>}/>
        <Route path='/security' element={<SecurityPage/>}/>
        <Route path='/about-us' element={<AboutUsPage/>} />
        <Route path='/faq' element={<FAQPage/>}/>
        <Route path='/pricing' element={<PricingPage/>}/>
        <Route path='/release-notes' element={<ReleaseNotes/>}/>
        <Route path='/404' element={<Error404Page/>}/>
        <Route path='*' element={<Navigate to='/404' replace />}/>
      </Routes>
      <Footer/>
       
       
    </div>
  )
}

export default MainRouting
